<button
  [id]="id + '18a5e2d8-b7e6-46e6-959b-aa7c732f72d8'"
  [disabled]="isDisabled"
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [class.left]="position === 'left'"
  [class.middle]="position === 'middle'"
  [class.right]="position === 'right'"
  (click)="buttonClick()">
  <yat-icon id="98f50030-f436-4da5-b21f-35d872cb76ad" [name]="iconName" [class]="iconSize" [multiColored]="isMulticolored"></yat-icon>
  <span [id]="id + '3c2b9bf3-9d1a-4968-80bd-4c208d4261b3'" [className]="textColor ? textColor : ''">{{ buttonName }}</span>
</button>
